import { useMemo } from 'react';
import S from './iframe.styles';
import { IframeProps } from './iframe.types';

export const Iframe: React.FC<IframeProps> = ({ conteudo, altoContraste }) => {
  return useMemo(
    () => (
      <S.Iframe
        tabIndex={0}
        data-testid="iframe-curso-complementar"
        src={
          altoContraste ? `${conteudo.url}?high-contrast=true` : conteudo.url
        }
        title={`Conteúdo Digital do Curso Complementar ${conteudo.titulo}`}
        allowFullScreen={true}
        allow="autoplay"
      />
    ),
    [altoContraste, conteudo.titulo, conteudo.url],
  );
};
